module.exports = __webpack_public_path__ + "i.no1.b38d3823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/i.no1.jpg
// module id = wQ1w
// module chunks = 0